import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import useGoogleAnalytics from "hooks/useGoogleAnalytics";
import NotFound from "pages/NotFound";
import MainFeed from './pages/main-feed';
import CreatePost from './pages/create-post';
import LandingPage from './pages/landing-page';

const RoutesContent = () => {
  useGoogleAnalytics();

  return (
    <RouterRoutes>
      {/* Define your route here */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/main-feed" element={<MainFeed />} />
      <Route path="/create-post" element={<CreatePost />} />
      <Route path="/landing-page" element={<LandingPage />} />
      <Route path="*" element={<NotFound />} />
    </RouterRoutes>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RoutesContent />
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
